import { TKeys } from './types'

export const hu_hu: Record<TKeys, string> = {
    ...require('./en-en').en_en, // TODO
    // SCREENS
    // General
    loading: 'Betöltés alatt...',
    // SignIn
    signin_title: 'Jelentkezzen be',
    signin_redirect_title: 'Jelentkezzen be és ellenőrizze jelszavát',
    psw_placeholder: 'Jelszó megerősítése',
    psw_placeholder_redirect: "Adja meg a jelszót",
    email_placeholder: 'E-mail cím',
    language: 'Nyelv',
    forgot_password: 'Feledte a jelszót?',
    signup_hint: 'Nincs fiókja? Regisztráljon',
    btn_signin: 'Jelentkezzen be',
    // Intro
    // N-Ary sort
    my_profile: 'Beállításaim',
    btn_submit: 'Küldés',
    btn_finish: 'Befejezés',
    hint_undo: 'Biztos vagy benne, hogy visszaállítani az utolsó műveletét?',
    // Global screen
    tip_quit: 'Biztos vagy benne, hogy kilépnéd?',
    // State screen // Tell us, what is your ideal work environment?
    intro_title: 'A boldogság a siker kulcsa',
    intro_body: `Ha szereti a munkáját és a csapatot, amellyel dolgozik, akkor sikeressé válik a szakmai életében.`,
    howto1_title: `Két állítást fog látni

    Kattintson az preferáltjára

    Ez csak 12 percig tart.`,
    howto1_body: `Ezt a tesztet csendes környezetben kell elvégeznie.`,
    award1_title: 'Jó munkát!',
    award1_body: `A következő listán a legfontosabb dolgokat fogja találni, amelyeket az ideális munkakörnyezetében tart. Ha kívánja, a kijelentések sorrendjét újra rendezheti, húzás és leengedés segítségével.`,
    award2_title: 'Több mint felére van már!',
    award2_body: `Merüljön bele a kalandba, amikor felfedezheti az ideális munkakörnyezetét A legfontosabb kijelentései a listán az első helyen vannak. Érezze a thrillt, amikor újra rendezheti őket, csak húzás és leengedés segítségével A álom munkahelye csak egy lépésre van!`,
    award3_title: 'Hozzászólás a harmadik részhez',
    award3_body: `'Már majdnem ott van A célvonal a szeme előtt van. Lélegezzen mélyen, adjon mindent ezekben a végpontokban, és ünnepelje a várható elképesztő eredményt. Tudja, hogy van. Erősítse a végét, és engedje, hogy a siker története folytatódjon!`,
    howto2_title: 'És most a végső kérdések - ±2 perc',
    howto2_body: `Egy-két további kérdést fog feltenni. Azt kell választania, hogy melyik a legjobb vagy a legrosszabb a már korábban rangsorolt kijelentések közül. Ez lehetővé teszi, hogy összevonjuk a három fordulója személyiségét.`,
    title_rank: 'Az **IDEALIS** munkakörnyezetemben',
    subtitle_rank_2: 'A legfontosabb dolog ...',
    subtitle_rank_n: 'Hol helyezné el a következő kijelentést?',
    hint_reorder: 'Rendezze újra, ha szükséges, a legfontosabbaktól a legkevésbé fontosakig',
    hint_overview: 'Kattintson az alábbi részletek megtekintéséhez',
    hint_profile: 'Jelenlegi beállításaim',
    hint_place_below: 'Helyezze el a kijelentést alább',
    title_rank_bucket: 'Nagyon utolsó összehasonlítások',
    subtitle_rank_best: 'Ebben az esetben, melyik a legfontosabb számára?',
    subtitle_rank_least: 'Melyik a legkevésbé fontos számára?',
    subtitle_rank_reorder: 'Rendezze újra a legfontosabbaktól a legkevésbé fontosakig',
    title_thanks: 'Jó munkát!',
    hint_thanks: 'A beállításai sikeresen elküldve',
    title_error: 'Nem tudjuk elküldeni az adatait',
    hint_error: 'Kérjük, próbálja újra később ...',
    hint_error_validation: 'Hiba történt a validálásnál, kérjük, próbálja újra később',
    hint_error_dup: 'Már elküldte az előző jelentést.',
    hint_confirm_round: 'Biztos vagy benne, hogy meg akarod erősíteni ezt a rangsort?',
    retry_btn: 'Újra',
    btn_to_overview: 'Összefoglaló',
    btn_to_bucket_x: 'Kosár',
    btn_to_params: 'Paraméterek',
    btn_open: 'Nyitva',
    btn_start: 'Kezdés',
    btn_confirm: 'Megerősítés',
    // btn_next: 'NEXT',
    btn_next: '>',
    btn_next_str: 'Következő',
    btn_next_round: 'Következő forduló',
    // btn_prev: 'PREV',
    btn_prev: '<',
    btn_cancel: 'Mégsem',
    // btn_back: 'BACK',
    btn_back: '<',
    btn_download: 'Letöltse a jelentését',
    btn_quit: 'Kilépés',
    // Comparisons
    pick_best: 'Melyik a legfontosabb számára?',
    pick_worst: 'Melyik a legkevésbé fontos számára?',
    vs: 'Vagy',
    // UI elements
    round: 'Forduló',
    stm: 'Kijelentés',
    bucket: 'Kosár',
    axis_y: 'Kijelentések száma',
    tip_saved: 'Mentve',
    top_scale_hint: 'A legfontosabb',
    bottom_scale_hint: 'A legkevésbé fontos',
    pick_tip: 'Választott!',
    how_to_binary_title: 'Utasítások',
    // values
    samen: 'Együttműködés',
    conf: 'Alkalmazkodás',
    erken: 'Elismerés',
    zorg: 'Gondoskodás',
    gelijk: 'Egyenlőség & sokszínűség',
    zelfsturing: 'Autonómia',
    macht: 'Hatalom',
    voorspelbaar: 'Kiszámíthatóság',
    prestatie: 'Teljesítmény',
    zelfontplooi: 'Önfejlesztés',
    duurzaam: 'Fenntarthatóság',
    integriteit: 'Feddhetetlenség',
    innovatie: 'Innováció',
    daadkracht: 'Erő',
    // 
    no_slug_error: 'Kérjük, ellenőrizze, hogy a megfelelő hivatkozást követte, ha igen, forduljon a rendszergazdához/támogatáshoz',
    unknown_error: 'Ismeretlen hiba történt, kérjük, próbálja újra később',
    invalid_credentials: 'Érvénytelen e-mail/címjelszó kombináció',
    // 360:
    // TLTM Scale
    lvl0: 'Kérjük, válasszon',
    lvl1: 'Jóval túl kevés',
    lvl2: 'Túl kevés',
    lvl3: 'Inkább túl kevés',
    lvl4: 'Megfelelő mennyiség',
    lvl5: 'Kicsit túl sok',
    lvl6: 'Túl sok',
    lvl7: 'Jóval túl sok',
    lvlx1: '-3',
    lvlx2: '-2',
    lvlx3: '-1',
    lvlx4: 'Megfelelő mennyiség',
    lvlx5: '+1',
    lvlx6: '+2',
    lvlx7: '+3',
    // SCALE 10 lvlSC10x
    lvlSC10x00: 'Kérem, válasszon',
    lvlSC10x00e: '🤔',
    //
    lvlSC10x0e: '😫',
    lvlSC10x0nps: 'Soha',
    lvlSC10x0: 'Nincs',
    lvlSC10x1e: '😖',
    lvlSC10x1nps: 'MISSING',
    lvlSC10x1: 'Rendkívül rossz',
    lvlSC10x2e: '😣',
    lvlSC10x2nps: 'MISSING',
    lvlSC10x2: 'Nagyon rossz',
    lvlSC10x3e: '😠',
    lvlSC10x3nps: 'MISSING',
    lvlSC10x3: 'Elégtelen',
    lvlSC10x4e: '🙁',
    lvlSC10x4nps: 'MISSING',
    lvlSC10x4: 'Rossz',
    lvlSC10x5e: '😯',
    lvlSC10x5nps: 'MISSING',
    lvlSC10x5: 'Közepes',
    lvlSC10x6e: '😐',
    lvlSC10x6nps: 'MISSING',
    lvlSC10x6: 'Átlagos',
    lvlSC10x7e: '🙂',
    lvlSC10x7nps: 'MISSING',
    lvlSC10x7: 'Jó',
    lvlSC10x8e: '😊',
    lvlSC10x8nps: 'MISSING',
    lvlSC10x8: 'Nagyon jó',
    lvlSC10x9e: '😃',
    lvlSC10x9nps: 'MISSING',
    lvlSC10x9: 'Kiváló',
    lvlSC10x10e: '😍',
    lvlSC10x10nps: 'Természetesen',
    lvlSC10x10: 'Kifogástalan',
    howto_360_title: `Az szervezetekben nagy hangsúlyt fektetünk a értékekre, és hiszünk, hogy fontos, hogy tudjuk, mi tesz igazán boldoggá minket a munkahelyünkön.`,
    howto_360_body: `'Ez a kérdőív anónim marad és marad, és a hierarchia csak a összesített eredményeket fogja kapni`,
    picker_360_title_workenv: "Az aktuális munkahelyemen …",
    picker_360_title_leadership: "A közvetlen vezetőm …",
    nps_title: "Szeretne-e itt dolgozni bárkinek, akit ismer",
    comment_title: 'Hozzászólás hozzáadása',
    comment_placeholder: 'Köszönjük az ezzel kapcsolatos bármilyen konstruktív visszajelzését',
    comment_save: 'Mentés és bezárás',
    comment_remaining: 'character(s) left',
    howto_workenv_title: 'And now, your work environment',
    howto_workenv_body: 'What about it ? Last questions, we promise!',
    howto_nps_title: "",
    howto_nps_body: "",
    // legacy_v2:
    btn_next_step: 'Tovább',
    to_assign: 'Hozzárendelésre vár',
    least_important: 'Legkevésbé fontos',
    moderately_important: 'Közepesen fontos',
    most_important: 'Legfontosabb',
    ranker_title: 'Mi fontos számodra az ideális munkádban?',
    too_insufficient_warning: 'Ez a csoport túl kevés állítást tartalmaz',
    too_much_warning: 'Ez a csoport túl sok állítást tartalmaz',
    too_much_warning1: 'Túl sok állítást rendeltél a következő csoport(ok)hoz:',
    too_much_warning2: 'Kattints a csoportra, és rendeld át az állítást egy másik csoportba, amíg a felosztás megfelelő nem lesz',
    empty_bin: 'Ez a csoport üres',
    // further_ranking: 'Kérjük, rangsorold tovább a(z) {{v1}} állítást, amelyeket "{{v2}}" kategóriába soroltál',
    further_ranking: 'Mi fontos számodra az ideális munkádban?',
    hint_modal_title: 'Képzeld el az ideális munkahelyi környezeted',
    hint_modal_body1: 'Rangsorold 42 állítást az ideális környezetedről a legkevésbé fontostól a legfontosabbig',
    hint_modal_body2_left: 'balra',
    hint_modal_body2_left_txt: 'az a 11 állítás, amelyet a legkevésbé fontosnak tartasz',
    hint_modal_body2_right: 'jobbra',
    hint_modal_body2_right_txt: 'az a 11 állítás, amelyet a legfontosabbnak tartasz',
    hint_modal_body2_middle: 'középre',
    hint_modal_body2_middle_txt: 'az a 20 állítás, amelyet közepesen fontosnak tartasz',
    hint_modal_body3: 'Húzd át minden egyes állítást abba a csoportba, amely a legjobban megfelel neked',
    hint_modal_cta: 'Indítás',
    hint_top: 'Görgetés fel',
    hint_down: 'Görgetés le',
    final_distribution_invalid_title: 'A végső elosztás érvénytelen',
    final_distribution_invalid_body: '{{v1}} rekesz van túl sok kijelentéssel és {{v2}} rekesz van túl kevés kijelentéssel',
    no_available_bins_warning: 'Nincs elérhető rekesz a véletlenszerű hozzárendeléshez - minden rekesz elérte a maximális kapacitását',
    sort_middle_bucket_title: 'Szeretné rendezni a középső rekeszt?',
    sort_middle_bucket_body: 'Ez érték szerint rendezi a középső rekeszt.',
    reflect_current_view_title: 'Ez tükrözi a jelenlegi nézetét?',
    reflect_current_view_sort_body: 'Ha nem, felajánljuk a végső rangsorolás rendezését',
    yes: 'Igen',
    no: 'Nem',
    final_ranking: 'Végső rangsor',
    example: 'Példa :',
}